// core feature do not remove this line
import PluginController from './plugin-core-system/plugin.controller.js';

// import essentials
import CsPhoneLinks from './essentials/cs-phone-links.js';
import CsExternalLinks from './essentials/cs-external-links.js';
import CsScrollbar from './essentials/cs-scrollbar.js';

// import custom plugins
import CsModalManager from './plugins/cs-modal-manager.js';
import CsMainNavigation from './plugins/cs-main-navigation.js';
import CsSplide from './plugins/cs-splide.js';
import CsResponsiveVideo from './plugins/cs-responsive-video.js';
import CsLightbox from './plugins/cs-lightbox.js';
import CsScrollToNextFrame from './plugins/cs-scroll-to-next-frame.js';
import CsEdgeNav from './plugins/cs-edge-nav.js';
import CsAccordion from './plugins/cs-accordion.js';
import CsFlipText from './plugins/cs-flip-text.js';
import CsAccessibilityAnimation from './plugins/cs-accessibility-animation.js';
import CsCookieBannerRenderer from './plugins/cs-cookie-banner-renderer.js';
import CsCookieBannerHandler from './plugins/cs-cookie-banner-handler.js';

// register plugins for initializing
PluginController.addPlugin('CsModalManager', CsModalManager);

PluginController.addPlugin('CsPhoneLinks', CsPhoneLinks, 'a[href^="tel:"]');
PluginController.addPlugin('CsExternalLinks', CsExternalLinks, 'a[target="_blank"]');
PluginController.addPlugin('CsAccessibilityAnimation', CsAccessibilityAnimation, '.js-toggle-animations');

PluginController.addPlugin('CsScrollbar', CsScrollbar);
PluginController.addPlugin('CsMainNavigation', CsMainNavigation, '.js-menu-main');
PluginController.addPlugin('CsSplide', CsSplide, '.js-splide-slider');
PluginController.addPlugin('CsResponsiveVideo', CsResponsiveVideo, '.js-responsive-video');
PluginController.addPlugin('CsLightbox', CsLightbox);
PluginController.addPlugin('CsScrollToNextFrame', CsScrollToNextFrame, '.js-scroll-to-next-frame');
PluginController.addPlugin('CsEdgeNav', CsEdgeNav, '.js-edge-nav');
PluginController.addPlugin('CsAccordion', CsAccordion, '.js-accordion');
PluginController.addPlugin('CsFlipText', CsFlipText, '.js-flip-text-trigger');
PluginController.addPlugin('CsCookieBannerRenderer', CsCookieBannerRenderer, '.js-cscb-edit-box');
PluginController.addPlugin('CsCookieBannerHandler', CsCookieBannerHandler, '.js-cscb-edit-box');

// core feature must be placed at the bottom of this script
document.addEventListener('DOMContentLoaded',
  () => PluginController.initializeAllPlugins(), false);
